import { DataGrid } from '@mui/x-data-grid'
import { Grid } from "@mui/material"

import styles from './campaignStyle'
import { withStyles } from '@material-ui/core/styles'
import { format } from 'date-fns'

const SignUp = ({ classes, visitorsInfo}) => {
    const rows = visitorsInfo.map((ele) => {
        return {
            "date": ele.date,
            "main": ele.signup,
            "unique_signup": ele.unique_signup
        }
    })

    const columns = [
        {
            field: 'date',
            headerName: 'Date',
            width: 100,
            
        },
        {
            field: 'main',
            headerName: 'Total Visits',
            width: 100,
            align: 'center'
        },
        {
            field: 'unique_signup',
            headerName: 'Unique Count',
            width: 100,
            align: 'center'
        }
    ]
 
    return (
        <Grid
        mt="6%"
        className={classes.horizantalTablayout}
        >
            <DataGrid
                className={classes.customDataGrid}

                rows={rows}
                columns={columns}
                getRowId={(row) => row.date}
                sx={{
                    '--DataGrid-containerBackground': '#131E2E',
                    '--DataGrid-rowBorderColor': '#000',
                    'border': 0,
                }}

                initialState={{
                    pagination: {
                        paginationModel: { page: 0, pageSize: 10 },
                    },
                }}

                pageSizeOptions={[10, 25, 50]}// Srini - 12/11/24
            />
        </Grid>
    )
}

export default withStyles(styles)(SignUp)